import React, { useRef, useEffect } from "react";
import { SubHeader } from "clearsense-ui/components";
import { useUserState } from "contexts/user";

export default function DataExplorer() {
    const containerRef = useRef(null);

    const user = useUserState();

    useEffect(() => {
        if (window.DataExplorer && containerRef.current) {
            window.DataExplorer.mount(containerRef.current, {
                api_url: process.env.DATA_EXPLORER_API_URL,
                routerBase: "/consumption/reporting/data-explorer",
                user,
            });
        }
        return () => {
            if (window.DataExplorer) {
                window.DataExplorer.unmount();
            }
        };
    }, [containerRef.current]);

    return (
        <div className="multi-source-report__wrapper px-8 min-h-0 flex-1">
            <SubHeader
                breadcrumbs={[{ label: "Data Explorer", link: "#" }]}
                className="p-4"
            />
            <div ref={containerRef}></div>
        </div>
    );
}
